<template>
    <div class="group-main">
        <GroupNavbar :items="devices" :device="current" @on-change-device="changeDevice"></GroupNavbar>
        <!-- action buttons -->
        <Actions :devices="devices" :gid="gid" @on-device-change="getDevices">
            <div slot="headerExtra" v-show="current.kind==9">
                <Button class="shadow112006" type="info" icon="md-arrow-round-forward" v-show="tmcShowStatus==0" @click="tmcShowStatus=1">{{$t('b_seeTMCDetail')}}</Button>
                <Button class="shadow112006" type="error" icon="md-arrow-round-back" v-show="tmcShowStatus==1" @click="tmcShowStatus=0">{{$t('b_exitTMCDetail')}}</Button>
            </div>
        </Actions>
        <components :is="componentId" :device="current" :tmcShowStatus="tmcShowStatus" v-if="isRouterAlive"></components>
        <GroupFooter></GroupFooter>
    </div>
</template>
<script>
import CADryer from './components/cadryer.vue';
import ConveyorBelt from './components/conveyorbelt.vue';
import FeedSystem from './components/feedsystem.vue';
import HedDryer from './components/heddryer.vue';
import Injection from './components/injection.vue';
import MoldTemp from './components/moldtemp.vue';
import Robot from './components/robot.vue';
import ThreeMachine from './components/threemachine.vue';
import TMC from './components/tmc.vue';
import CoolWater from './components/coolwater.vue';
import InjectionKLS from './components/injectionkls.vue';
import RobotTRC from './components/robottrc.vue';
import ThreeMachineSF from './components/threemachinesf.vue';
import Mold from './components/mold.vue';
import CapDetection from './components/capdetection.vue';

import GroupNavbar from './components/navbar.vue';
import Actions from './components/actions.vue';
import GroupFooter from '@/views/main_components/footer.vue';
import Axios from 'axios';
import AxiosUrl from '@/axiosurl.js';

export default {
    name: 'group',
    components: {
        Actions,
        GroupNavbar,
        CADryer,
        ConveyorBelt,
        FeedSystem,
        HedDryer,
        Injection,
        MoldTemp,
        Robot,
        ThreeMachine,
        TMC,
        CoolWater,
        GroupFooter,
        InjectionKLS,
        RobotTRC,
        ThreeMachineSF,
        Mold,
        CapDetection
    },
    data() {
        return {
            isRouterAlive: true,
            tmcShowStatus: 0, //温控箱的显示状态，是全部还是单
            gid: this.$route.params.gid, // 机组ID
            devices: [], // 设备列表
            current: {
                dev_id: 0,
                kind: 0
            } // 当前设备
        };
    },
    computed: {
        componentId() {
            let cs = ['', 'MoldTemp', 'ThreeMachine', 'CoolWater', 'CADryer', 'ConveyorBelt', 'FeedSystem', 'Robot', 'Injection', 'TMC', 'HedDryer', '', 'InjectionKLS', 'RobotTRC', 'ThreeMachineSF', '', '', '', '', '', 'Mold', 'CapDetection'];
            // let cs = ['', '模温机(KH54401A)', '三机一体(DF879500A)', '冷水机(SF306000A)', '压缩空气干燥机(D-100)', '传送带', '自动供料控制器', '机械手(TRC-1100)', '注塑机(JSU)', 'TMC温控箱', 干燥机(HC-100), '',注塑机(KLS),机械手(TRC-990),三机一体(SF879500A),'','','','','',模具,瓶盖检测自动化];
            return cs[this.current.kind];
        }
    },
    mounted() {
        this.getDevices();
    },
    methods: {
        // 获取当前机组设备列表
        getDevices() {
            Axios.get(AxiosUrl.group.devices, {
                params: {
                    gid: this.gid
                }
            })
                .then(res => {
                    let { code, data } = res.data;
                    if (code == 200) {
                        this.devices = data;
                        if (this.devices.length == 0) {
                            this.$Message.warning(this.$t('b_noDevice'));
                        } else {
                            this.current = this.devices[0];
                        }
                    } else {
                        let { msg } = res.data;
                        this.$Message.error(res.data.msg);
                    }
                })
                .catch(error => {});
        },
        // 变更当前选中设备
        changeDevice(dev) {
            // 重载
            this.isRouterAlive = false;
            this.$nextTick(() => (this.isRouterAlive = true));
            this.tmcShowStatus = 0;
            this.current = dev;
        }
    }
};
</script>
<style lang="less">
.group-main {
    .base-dl {
        height: 167px;
        dt {
            float: left;
            width: 150px;
            padding: 10px 20px 10px 0;
            text-align: right;
            font-weight: bold;
        }
        dd {
            margin-left: 150px;
            padding: 10px 0;
        }
    }
    .dat-dl {
        height: 537px;
        dt {
            float: left;
            width: 25%;
            padding: 10px 20px 10px 0;
            text-align: right;
            font-weight: bold;
        }
        dd {
            float: left;
            width: 25%;
            padding: 10px 0;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
    .watch {
        height: 167px;
        display: flex;
        align-items: center;
        justify-content: space-around;
        .tx {
            font-size: 14px;
            font-weight: bold;
        }
        .val {
            font-size: 36px;
        }
    }
    .echart-pie {
        height: 167px;
    }
    .echart-line {
        width: 100%;
        height: 537px;
    }
    .charts-radio {
        display: flex;
        height: 100%;
        align-items: center;
        padding-right: 15px;
        .date-select,
        .date-select + div {
            display: flex;
            align-items: center;
            > span {
                flex-shrink: 0;
                min-width: 67px;
            }
            > div {
                flex: 1;
            }
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/views/group/group.vue